<template>
    <div class="mainCont">
        <div>
            <el-backtop :right='15'></el-backtop>
        </div>
       <el-button class="gt_back" icon="el-icon-arrow-left" size="small" @click="$router.go(-1)">返回</el-button>
       <div class="cont">
            <img src="~@/assets/images/guidance/1.png" alt="">
            <img src="~@/assets/images/guidance/2.png" alt="">
            <img src="~@/assets/images/guidance/3.png" alt="">
            <img src="~@/assets/images/guidance/4.png" alt="">
            <img src="~@/assets/images/guidance/5.png" alt="">
            <img src="~@/assets/images/guidance/6.png" alt="">
            <img src="~@/assets/images/guidance/7.png" alt="">
            <img src="~@/assets/images/guidance/8.png" alt="">
            <img src="~@/assets/images/guidance/9.png" alt="">
            <img src="~@/assets/images/guidance/10.png" alt="">
       </div>
       <!-- 移动端显示 -->
        <div class="mobileTest">
           <MobileComNav title="帮助中心"></MobileComNav>
        </div>
    </div>
</template>

<script>
    import MobileComNav from "../../../components/mobileHead";
    export default {
        components: {
            MobileComNav
        },
        data(){
            return {

            }
        },
        mounted(){
             document.title=this.$route.meta.title
        }
    }
</script>

<style scoped>
    .gt_back{
        margin:0.2rem 0 0.1rem;
    }
    .cont img{
        width: 100%;
    }
    .mobileTest{
        display: none;
    }
    @media screen and (max-width: 768px) {
        .mobileTest{
            display: block;
        }
    }
</style>
